import IconHeart from '../../components/icons/IconHeart';
import { achievementLevel } from './config';

const skClubAchievements = [
  {
    name: 'SK Club Member',
    description: 'Link your wallet with your SK Club account',
    category: 'SK Club',
    level: achievementLevel.bronze,
    icon: <IconHeart />,
    requirements: {
      skClubLinked: true,
    },
  },
];

export default skClubAchievements;
